import {Mapper} from '@s-ui/domain'

export default class FromMarketedMakeRawDataToMarketedMakeEntityFactoryMapper extends Mapper {
  constructor({config, makeEntityFactory, toCapitalCase}) {
    super()
    this._config = config
    this._makeEntityFactory = makeEntityFactory
    this._toCapitalCase = toCapitalCase
    this.imagesUrl = this._config.get('URL_MAKES_IMAGES')

    this.mostSearched = this._config.get('vehicles').mostSearched
  }

  _normalizeName = name => name.toLowerCase().replace(/ /g, '_')

  _getIsMostSearched = id => this.mostSearched.includes(id)

  setParams = params => {
    const {urlPrefix} = params
    this._urlPrefix = urlPrefix

    return this
  }

  map = ({key: id, value: name}) => {
    const normalizedName = this._normalizeName(name)
    const url = `${this._urlPrefix}${normalizedName}/`
    const image = `${this.imagesUrl}${normalizedName}.jpg`
    const make = {
      id,
      name,
      url,
      image,
      isMostSearched: this._getIsMostSearched(id)
    }

    return this._makeEntityFactory({...make})
  }
}
